import { PaginationValues } from "../../types/General/PaginationValues";
import { IndicatorDataReportRegion } from "../../types/Indicator/IndicatorDataReport/IndicatorDataReportRegion";
import api from "../../utils/api";
import { INDICATOR_REGION_URL } from "../../utils/endpoints";

export async function getIndicatorRegion(
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    if (!filterValues.ProvinceId) {
      return { content: [], totalItems: 0 };
    }
    const response = await api.get(`${INDICATOR_REGION_URL}`, {
      params: {
        ...filterValues,
        ...paginationValues,
      },
    });

    const data: IndicatorDataReportRegion[] = response.data.result.map(
      (option: IndicatorDataReportRegion) => ({
        indicator: option.indicator,
        reference: option.reference ?? null,
        currentValue: option.currentValue ?? null,
        lastValue: option.lastValue ?? null,
        lastLastValue: option.lastLastValue ?? null,
        lastYearValue: option.lastYearValue ?? null,
        currentWithPrevious: option.currentWithPrevious ?? null,
        currentWithPreviousYear: option.currentWithPreviousYear ?? null,
        state: option.state ?? null,
      }),
    );

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
